import { Box, Button, Grid, Typography } from "@mui/material"
import { DetailKeyValue } from "../../../../components"
import { useStyles } from "./styles"
import { OptionActionProps, OptionActionRef } from "./types"
import { DynamicFormRef } from "../../../../components/dynamicFormRef"
import { OptionActionsBody } from "./body"
import { FloatsComponents } from "../floatsComponents"
import dayjs from "dayjs"
import { Ref, forwardRef } from "react"
import { ArrowBack } from "../../../../components/arrowBack"
import { LoadingButton } from "@mui/lab"
import { CustomeDrawer } from "../../../../components/customeDrawer"
import { useTranslation } from "react-i18next"

const OptionActions = forwardRef((props: OptionActionProps, ref: Ref<OptionActionRef>) => {
    const { t } = useTranslation()
    const styles = useStyles()
    return OptionActionsBody({
        defaultData: props.defaults,
        active: props.active,
        save: props.save,
        aaveragePoints: props.averagePoints,
        permission: props.permission,
        refBody: ref,
        display: props.display,
        children: ({ actions, actionPlan, evidence, evidenceData, defaultChecks, reincidence, returnQuestonnaire, closeActionPlan, saveReincidence, closeReincidence, reportFolio, totalPoint, commentRef, comment, commentEvidenceData, defaultComment, savecommentEvidence, addRef, closeReportFolioByAnswer, getReportFolioByAnswer, onChange, saveData, saveActionPlan, saveEvidence }) => {
            return (
                <CustomeDrawer open={!!props.drawerProps?.open}>
                    <>
                        <Box sx={styles.body}>
                            <Box sx={styles.container}>

                                <Box sx={styles.headerArrow}>
                                    <ArrowBack
                                        label="Volver al cuestionario"
                                        arrowProps={{
                                            onClick: (e) => {
                                                e.stopPropagation()
                                                e.preventDefault()
                                                returnQuestonnaire()
                                            }
                                        }}
                                        boxProps={{
                                            sx: { padding: 0 }
                                        }}
                                    />
                                    {
                                        !props.noHeader && (
                                            <Box sx={styles.header}>
                                                <Typography>Creado por: {props?.header?.created ?? ''}</Typography>
                                                <Typography>{dayjs(props?.header?.date).format('DD/MM/YYYY')}</Typography>
                                            </Box>
                                        )
                                    }
                                </Box>

                                {
                                    (!props.detailConfig && !props?.noHeader) && (
                                        <Grid container spacing={1}>
                                            <Grid item xs={4}>
                                                <DetailKeyValue
                                                    name=""
                                                    align="center"
                                                    padding='0px'
                                                    value={String(props.sectionAmount ?? 0)}
                                                    caption="Secciones"
                                                    sxContainer={styles.keyValue}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <DetailKeyValue
                                                    name=""
                                                    align="center"
                                                    padding='0px'
                                                    value={String(props.questionAmount ?? 0)}
                                                    caption="Preguntas"
                                                    sxContainer={styles.keyValue}
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <DetailKeyValue
                                                    name=""
                                                    align="center"
                                                    padding='0px'
                                                    value={String(totalPoint ?? 0)}
                                                    caption="Ptos. Totales"
                                                    sxContainer={styles.keyValue}
                                                />
                                            </Grid>
                                        </Grid>
                                    )
                                }
                                {
                                    !!props.detailConfig && (
                                        <Typography sx={styles.label}>{props.detailConfig.labels?.join(' - ')}</Typography>
                                    )
                                }
                                <Typography sx={styles.title}>{props.detailConfig?.title ?? 'Configuración de cuestionario'}</Typography>

                                {
                                    !!props.detailConfig && (
                                        <>
                                            {Boolean(props.detailConfig.description) && <Typography sx={styles.description}>{props.detailConfig.description}</Typography>}

                                            {Boolean(props.detailConfig.answer) && <Typography sx={styles.answer}>{props.detailConfig.answer}</Typography>}
                                        </>
                                    )
                                }
                                <DynamicFormRef
                                    ref={(element) => addRef({ element, name: 'options' })}
                                    model={actions}
                                    defaultValues={defaultChecks}
                                    onChange={onChange}
                                    parentWrapper={(parent) => <Grid container spacing={1} children={parent.children} />}
                                />
                            </Box>

                            <Box sx={styles.footer}>
                                <Button onClick={(e) => {
                                    e.stopPropagation()
                                    e.preventDefault()
                                    if (props.footerButtons?.left) {
                                        props.footerButtons?.left.click()
                                    } else {
                                        saveData()
                                    }
                                }} variant="contained">{props.footerButtons?.left?.label ?? t('general.save')}</Button>

                                {
                                    props.footerButtons?.right && (
                                        <LoadingButton
                                            variant="outlined"
                                            loading={!!props.footerButtons?.right?.loading}
                                            onClick={() => {
                                                if (props.footerButtons?.right) {
                                                    props.footerButtons?.right.click()
                                                }
                                            }}>{props.footerButtons?.right?.label}</LoadingButton>
                                    )
                                }
                            </Box>
                        </Box>

                        <FloatsComponents
                            isGeneral={!props?.noHeader}
                            display={props.display}
                            cancelActionPlan={closeActionPlan}
                            reincidence={{
                                ...reincidence,
                                close: closeReincidence,
                                saveReincidence: saveReincidence,
                            }}
                            actionPlan={{
                                open: actionPlan.open,
                                title: actionPlan.title,
                                arrowBack: saveActionPlan,
                                defaultValues: actionPlan.defaultValues
                            }}
                            evidence={{
                                data: { ...evidence ?? {}, evidencesData: evidenceData },
                                saveEvidence
                            }}
                            reportFolio={{
                                arrowBack: getReportFolioByAnswer,
                                cancel: closeReportFolioByAnswer,
                                default: reportFolio?.default,
                                data: reportFolio?.evidence,
                                id: reportFolio?.id ?? null
                            }}
                            comments={{
                                evidence: {
                                    saveEvidence: savecommentEvidence,
                                    data: { ...comment, evidencesData: commentEvidenceData }
                                },
                                defaultComment: defaultComment,
                                ref: commentRef
                            }}
                        />
                    </>
                </CustomeDrawer>
            )
        }
    })
})

export { OptionActions }
